var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"block",attrs:{"loading":_vm.loading}},[(_vm.title)?_c('h1',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.title)?_c('v-divider',{staticClass:"title-divider"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }